import { MutationTree } from 'vuex';
import { ACCOUNT } from './mutation-types';
import { AccountState, state as initialState } from './state';

export const mutations: MutationTree<AccountState> = {
    [ACCOUNT.SET_SOCIETES](state, societeIds) {
        state.societeIds = societeIds;
    },
    [ACCOUNT.RESET](state) {
        Object.assign(state, initialState);
    },
};
